import { render } from "./CropImageModal.vue?vue&type=template&id=08c79939&scoped=true"
import script from "./CropImageModal.vue?vue&type=script&lang=js"
export * from "./CropImageModal.vue?vue&type=script&lang=js"

import "./CropImageModal.vue?vue&type=style&index=0&id=08c79939&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c79939"],['__file',"CropImageModal.vue"]])

export default __exports__